/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterAtv1EnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_ATV1_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterAtv1EnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterAtv1EnabledSettingParser.decode(input).map(res => new TierStarterAtv1EnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterAtv1EnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterAtv1EnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterAtv1EnabledSettingParser.schema();
    }
}
